export type PercentageInputValue = number | null;
